import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-two-lesson-two-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitTwoLessonTwoGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 2, Lesson 2 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 2: Employment and Education Goals";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
